type CardProps = {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  children?: React.ReactNode;
};

const Card = ({ title, description, icon, children }: CardProps) => {
  return (
    <div className={"space-y-4 rounded-lg border border-secondary p-5 shadow-md"}>
      {icon}
      <div>
        {title && <h3 className={"text-xl font-semibold text-primary"}>{title}</h3>}
        {description && <p className={"text-sm text-quaternary"}>{description}</p>}
      </div>
      {children}
    </div>
  );
};

export default Card;
